export class ProjectType {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): ProjectType {
    return new ProjectType(
      json['id'],
      json['name'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}